import { toast } from 'react-toastify';
import { API_NOTIFICACIONES } from '../../views/MainLayout/components/shared/services/notificaciones';
import { setErrorMessage } from '../../views/MainLayout/components/shared/helpers/functionalities';

const initialState = {
    activas: {
        data: [],
        total_items: 0,
        loaded: false,
    },
    archivadas: {
        data: [],
        total_items: 0,
        loaded: false,
    },
};

export const notificacionesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'notificaciones/setActivas':
            return {
                ...state,
                activas: {
                    data: action.payload.notificaciones,
                    total_items: action.payload.total_notificaciones,
                    loaded: true,
                },
            };

        case 'notificaciones/setArchivadas':
            return {
                ...state,
                archivadas: {
                    data: action.payload.notificaciones,
                    total_items: action.payload.total_notificaciones,
                    loaded: true,
                },
            };
        case 'notificaciones/archivarTodas':
            return {
                ...state,
                activas: {
                    data: [],
                    total_items: 0,
                    loaded: true,
                },
            };
        case 'notificaciones/desarchivar':
            return {
                ...state,
                activas: {
                    ...state.activas,
                    total_items: state.activas.total_items + 1,
                },
            };
        default:
            return state;
    }
};

export const fetchNotificaciones =
    ({ tipo = 'activas', page = 1 }) =>
    async (dispatch) => {
        try {
            const response = await API_NOTIFICACIONES.getNotificaciones(tipo, page);
            const data = await response.data;

            if (tipo === 'activas') {
                dispatch({ type: 'notificaciones/setActivas', payload: data });
            } else {
                dispatch({
                    type: 'notificaciones/setArchivadas',
                    payload: data,
                });
            }
        } catch (e) {
            toast.error(setErrorMessage(e));
        }
    };

export const archivarTodas = () => async (dispatch) => {
    try {
        dispatch({ type: 'notificaciones/archivarTodas' });
    } catch (e) {
        toast.error(setErrorMessage(e));
    }
};

export const desarchivarNotificacion = () => async (dispatch) => {
    try {
        dispatch({ type: 'notificaciones/desarchivar' });
    } catch (e) {
        toast.error(setErrorMessage(e));
    }
};
